"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userResourceSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = { user: null, role: null, studyUser: null };
exports.userResourceSlice = (0, toolkit_1.createSlice)({
    name: "userResource",
    initialState,
    reducers: {
        upsert(state, action) {
            state.user = action.payload.user;
            state.role = action.payload.role;
            state.studyUser = action.payload.studyUser;
        },
    },
});
//# sourceMappingURL=userResource.js.map